// extracted by mini-css-extract-plugin
export default {"react-flow__controls-button":"index_react-flow__controls-button__YdqRG","minimap":"index_minimap__dD-PT"};